<ui-input-wrapper [label]="label()" [value]="value()" [focussed]="focussed()" [error]="error()" [errorMsg]="errorMsg()">
    <input
        class="flex h-full w-full items-center px-16 text-transparent outline-none transition-all"
        [ngClass]="{
            '!text-black': value() || focussed() || !label(),
        }"
        [type]="type()"
        [value]="value() ?? null"
        [placeholder]="placeholder()"
        (input)="setValue($event)"
        (focus)="_onTouch?.(); focussed.set(true)"
        (blur)="focussed.set(false)"
    />
</ui-input-wrapper>
